import Button from '@rio-cloud/rio-uikit/Button';
import { useState } from 'react';

interface Props {
    toggleWidth: () => void;
    isFullWidth: boolean;
}

export const WidthToggleButton = (props: Props) => (
    // Changing key is important to remove highlighting of button
    <Button
        key={props.isFullWidth ? 1 : 0}
        className='btn btn-default btn-icon-only'
        onClick={props.toggleWidth}
        autoTrackingKey='marketplace.usage.toggleWidth.button'
    >
        <span
            data-testid='resize-glyph'
            className={`uikit-icon ${props.isFullWidth ? 'icon-resize-small' : 'icon-resize-full'}`}
            aria-hidden={true}
        />
    </Button>
);

export const useWidthToggleState = () => {
    const [isFullWidth, setFullWidth] = useState(false);
    const toggleWidth = () => setFullWidth(state => !state);
    return { isFullWidth, toggleWidth };
};
